module.exports = __webpack_public_path__ + "img/laser-turret.b18cccea.svg";